import { DocumentNode, OperationVariables, TypedDocumentNode, useQuery } from '@apollo/client'

/**
 * Used for calling an apollo query imperatively, this allows to await for query response which is not currently supported by apollo:
 * https://github.com/apollographql/react-apollo/issues/3499
 */
export const useImperativeQuery = (
  query: DocumentNode | TypedDocumentNode<any, OperationVariables>
) => {
  // query is skipped so it's only called on refetch
  const { refetch } = useQuery(query, { skip: true })

  const imperativelyCallQuery = (variables?: Partial<OperationVariables> | undefined) => {
    return refetch(variables)
  }

  return imperativelyCallQuery
}
